module.exports = __webpack_public_path__ + "media/images/amenities_icons/professional_lighting_equipment-e70259bf335d27bc97cfe93673a7bf99.svg";